module.exports = __webpack_public_path__ + "static/media/about-1.a0e92779.svg";